module.exports = __webpack_public_path__ + "assets/lotterying-box-cad1691e.svga";